import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UnreadAttributeIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <path d="M13.0319 7.66669V10.6c0 .6234-.51 1.1334-1.1334 1.1334H3.96521L1.69855 14V3.80002c0-.62333.51-1.13333 1.13333-1.13333h5.44417c-.034.18133-.05667.374-.05667.56666 0 .19267.02267.38534.05667.56667H2.83188V10.6h9.06662V7.66669h1.1334Zm0-1.66667c-1.4756 0-2.6667-1.19111-2.6667-2.66667 0-1.47555 1.1911-2.666663 2.6667-2.666663S15.6986 1.8578 15.6986 3.33335c0 1.47556-1.1911 2.66667-2.6667 2.66667Z" />
  </Icon>
);

export default memo(UnreadAttributeIcon);
